const MIN_RECT = 96;

export type SnapshotHandle = "body" | "tl" | "tr" | "bl" | "br";

export interface SnapshotRect {
  left: number;
  top: number;
  width: number;
  height: number;
}

export function resizeOrMove(
  start: SnapshotRect,
  handle: SnapshotHandle,
  dx: number,
  dy: number,
  parent: { w: number; h: number },
  minSize = MIN_RECT,
): SnapshotRect {
  let left = start.left;
  let top = start.top;
  let right = start.left + start.width;
  let bottom = start.top + start.height;

  switch (handle) {
    case "body": {
      const width = start.width;
      const height = start.height;
      left = clamp(left + dx, 0, Math.max(0, parent.w - width));
      top = clamp(top + dy, 0, Math.max(0, parent.h - height));
      right = left + width;
      bottom = top + height;
      break;
    }
    case "tl":
      left = clamp(left + dx, 0, right - minSize);
      top = clamp(top + dy, 0, bottom - minSize);
      break;
    case "tr":
      right = clamp(right + dx, left + minSize, parent.w);
      top = clamp(top + dy, 0, bottom - minSize);
      break;
    case "bl":
      left = clamp(left + dx, 0, right - minSize);
      bottom = clamp(bottom + dy, top + minSize, parent.h);
      break;
    case "br":
      right = clamp(right + dx, left + minSize, parent.w);
      bottom = clamp(bottom + dy, top + minSize, parent.h);
      break;
  }

  return {
    left,
    top,
    width: right - left,
    height: bottom - top,
  };
}

function clamp(n: number, min: number, max: number): number {
  return Math.min(max, Math.max(min, n));
}
